import { Box, Typography } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

type MessageSlaViewProps = {
  illustration: string;
  titleTextId: string;
  descriptionTextIds: string[];
  action: React.ReactNode;
};

export const CareTeamSlaView = (props: MessageSlaViewProps) => {
  const intl = useIntl();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'white',
        height: '100%',
      }}
    >
      <Box component='img' src={props.illustration} sx={{ width: '100%' }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          px: '15%',
          height: '100%',
        }}
      >
        <Typography
          sx={{ fontSize: 24, fontWeight: 600, mb: 10, textAlign: 'center' }}
        >
          {intl.formatMessage({ id: props.titleTextId })}
        </Typography>
        {props.descriptionTextIds.map((textId) => (
          <Typography key={textId} sx={{ mb: 5, alignSelf: 'flex-start' }}>
            {intl.formatMessage({ id: textId })}
          </Typography>
        ))}
        <Box sx={{ mt: 'auto', mb: 10, width: '100%' }}>{props.action}</Box>
      </Box>
    </Box>
  );
};
